import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
    IconButton,
    Switch,
    Grid,
    Button,
    FormHelperText,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    makeStyles
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { getCongineePdf, getConsignorPdf } from '../../../store/actions/tripActionCreator';
import { PictureIcon } from '../../../components/icons';
import BiltyReportView from '../Dialog/BiltyReportView';
import * as logger from '../../../logger';
import { SizeMe } from 'react-sizeme';
import { Document, Page, pdfjs } from 'react-pdf';


const useStyles = makeStyles((theme) => ({

    dialogContenV1: {
        paddingTop: 30,
        paddingBottom: 16,
        paddingLeft: 36,
        paddingRight: 36
    },
    daV1: {
        paddingRight: 36,
        paddingTop: 2,
        paddingBottom: 24,
        paddingLeft: 36
    },
    closeButtonV1: {
        backgroundColor: '#efeff2',
        fontWeight: 500,
        textTransform: 'capitalize',
        borderRadius: 4,
        marginRight: 16,
        paddingTop: 7,
        paddingBottom: 7,
        '&:hover': {
            backgroundColor: '#efeff2'
        }
    },
    downloadButton: {
        backgroundColor: '#5170f0',
        color: 'white',
        fontWeight: 500,
        borderRadius: 4,
        paddingTop: 10,
        paddingBottom: 10,
        textTransform: 'capitalize',
        width: 312,
        '&:hover': {
            backgroundColor: '#5170f0'
        }
    },
    divConsignor: {
        backgroundColor: '#e5446d',
        color: 'white',
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
        fontSize: 18,
        fontWeight: 'bold',
        paddingTop: 12,
        paddingBottom: 12,
        textAlign: 'center'
    },
    divContainer: {
        width: 312,
        height: '100%'
    },
    divContainerV1: {
        width: 312,
        marginLeft: 40,
        height: '100%'
    },
    divConsignorContainer: {
        border: '4px solid #d8dbe4',
        borderBottomLeftRadius: 8,
        borderBottomRightRadius: 8,
        paddingTop: 12,
        paddingBottom: 12,
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '90%'
    },
    divConsigneeContainer: {
        border: '4px solid #d8dbe4',
        borderBottomLeftRadius: 8,
        borderBottomRightRadius: 8,
        paddingTop: 12,
        paddingBottom: 12,
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '90%'
    },
    iconV2: {
        width: 64,
        height: 64
    },
    dialogTitleV1: {
        paddingLeft: 32,
        paddingRight: 32,
        paddingTop: 14,
        paddingBottom: 14,
        boxShadow: '0 4px 4px 0 rgba(0, 13, 23, 0.06)',
        "& .MuiTypography-root": {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }
    },
    closeButton: {
        fontSize: 18,
        color: 'grey',
    },
    divConsignee: {
        backgroundColor: '#00875a',
        color: 'white',
        fontSize: 18,
        fontWeight: 'bold',
        paddingTop: 12,
        paddingBottom: 12,
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
        textAlign: 'center'
    },
    editButton: {
        borderRadius: 4,
        border: '1px solid #5170f0',
        textTransform: 'capitalize',
        color: '#5170f0',
        paddingLeft: 24,
        paddingRight: 24,
        paddingTop: 7,
        paddingBottom: 7,
        fontWeight: 500
    },
    divV2: {
        display: 'flex',
        alignItems: 'center'
    },
    mlV1: {
        marginLeft: 24
    },
    divAlign: {
        display: 'flex',
        width: '100%',
        height: '100%'
    },
    paper1: {
        borderRadius: 8
    },
    paperWidth: {
        width: 736,
        maxWidth: 736,
        height: 720
    },
    pdfContainer: {
        border: '4px solid #d8dbe4',
        borderBottomLeftRadius: 8,
        borderBottomRightRadius: 8,
        height: '90%'
    },
    divActions: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between'
    }
}));

const BiltyReportPreview = ({ open, onClose, onEdit, user, dipatchGetConsigneePdf, disptachGetConsignorPdf, trip }) => {

    const classes = useStyles();

    const focusPdf = React.createRef();
    const [dialogOpen, setDialogOpen] = useState(open);
    const [biltyReportOpen, setBiltyReportOpen] = useState(false);
    const [congineePdf, setCongineePdf] = useState({});
    const [consignorPdf, setConsignorPdf] = useState({});
    const [pdfWidth, setPdfWidth] = useState(document.body.clientWidth - 35);
    const [numPages, setNumPages] = useState(null);
    const [checkPdf, setCheckPdf] = useState("");

    const tripId = user && user.singleTripData && user.singleTripData.id ? user.singleTripData.id : "";

    useEffect(() => {

        if (trip.congineePdf) {
            setCongineePdf(trip.congineePdf);
        }

        if (trip.consignorPdf) {
            setConsignorPdf(trip.consignorPdf)
        }

    }, [trip.congineePdf, trip.consignorPdf])

    useEffect(() => {

        dipatchGetConsigneePdf(
            tripId,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log('Bilty Report Preview', "Get Consignee PDF successfull");
                    disptachGetConsignorPdf(
                        tripId,
                        (data) => {
                            if (data && data.status && data.status.code == 200) {
                                logger.log('Bilty Report Preview', "Get Consignor PDF successfull");
                            }
                        },
                        () => {
                            logger.log('Bilty Report Preview', "Get Consignor PDF successfull");
                        }
                    );
                }
            },
            () => {
                logger.log('Bilty Report Preview', "Get Consignee PDF failed");
            }
        );

    }, [open]);

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
    }

    const handleEdit = () => {
        onEdit();
    }

    const handlePdfView = (value) => {
        setBiltyReportOpen(true);
        setCheckPdf(value);
    }

    const handleBiltyReportViewClose = () => {
        setBiltyReportOpen(false);
    }

    function onDocumentLoadSuccess({ numPages: nextNumPages }) {
        let header = document.getElementsByTagName('header')[0];
        if (header) {
            setPdfWidth(header.clientWidth - 60);
        }
        setNumPages(nextNumPages);
    }

    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

    return (
        <>
            <Dialog fullWidth={true}
                onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} open={dialogOpen} classes={{ paper: classes.paper1, paperWidthSm: classes.paperWidth }}>
                <DialogTitle className={classes.dialogTitleV1}>
                    <div className={classes.divV2}>
                        <div className={classes.divV1}>Online Bilty</div>
                        <div className={classes.mlV1}>
                            <Button variant="outlined" className={classes.editButton} onClick={() => handleEdit()} >
                                Edit
                            </Button>
                        </div>
                    </div>
                    <div>
                        <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </div>
                </DialogTitle>

                <DialogContent className={classes.dialogContenV1}>
                    <div className={classes.divAlign} >

                        <div className={classes.divContainer} onClick={() => handlePdfView('consignor')}>
                            <div className={classes.divConsignor}>
                                Consignor LR
                            </div>
                            {consignorPdf && consignorPdf.s3Link ? (
                                <>
                                    <div className={classes.pdfContainer}>
                                        <div className={classes.pdfSubContainer} tabIndex={0} ref={focusPdf} >
                                            <SizeMe>
                                                {({ size }) => (
                                                    <Document
                                                        file={consignorPdf && consignorPdf.s3Link ? consignorPdf.s3Link : null}
                                                        onLoadSuccess={onDocumentLoadSuccess}
                                                    >
                                                        {
                                                            Array.from(
                                                                new Array(numPages),
                                                                (el, index) => (
                                                                    <Page
                                                                        key={`page_${index + 1}`}
                                                                        pageNumber={index + 1}
                                                                        width={size.width ? size.width : 1}
                                                                    />
                                                                ),
                                                            )
                                                        }

                                                    </Document>
                                                )}
                                            </SizeMe>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <div className={classes.divConsignorContainer}>
                                    <PictureIcon className={classes.iconV2} />
                                </div>
                            )
                            }
                        </div>

                        <div className={classes.divContainerV1} onClick={() => handlePdfView('consignee')}>
                            <div className={classes.divConsignee}>
                                Consignee LR
                            </div>
                            {congineePdf && congineePdf.s3Link ? (
                                <>
                                    <div className={classes.pdfContainer}>
                                        <div className={classes.pdfSubContainer} tabIndex={0} ref={focusPdf} >
                                            <SizeMe>
                                                {({ size }) => (
                                                    <Document
                                                        file={congineePdf && congineePdf.s3Link ? congineePdf.s3Link : null}
                                                        onLoadSuccess={onDocumentLoadSuccess}
                                                    >
                                                        {
                                                            Array.from(
                                                                new Array(numPages),
                                                                (el, index) => (
                                                                    <Page
                                                                        key={`page_${index + 1}`}
                                                                        pageNumber={index + 1}
                                                                        width={size.width ? size.width : 1}
                                                                    />
                                                                ),
                                                            )
                                                        }

                                                    </Document>
                                                )}
                                            </SizeMe>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <div className={classes.divConsigneeContainer}>
                                    <PictureIcon className={classes.iconV2} />
                                </div>
                            )}
                        </div>

                    </div>
                </DialogContent>

                <DialogActions className={classes.daV1}>
                    <div className={classes.divActions}>
                        <a style={{ color: "#fff" }} href={consignorPdf && consignorPdf.s3Link ? consignorPdf.s3Link : ""} target="_blank" download>
                            <Button variant="contained" className={classes.downloadButton} >
                                Download Consignor LR
                            </Button>
                        </a>
                        <a style={{ color: "#fff" }} href={congineePdf && congineePdf.s3Link ? congineePdf.s3Link : ""} target="_blank" download>
                            <Button variant="contained" className={classes.downloadButton} >
                                Download Consignee LR
                            </Button>
                        </a>
                    </div>

                </DialogActions>

            </Dialog>

            {biltyReportOpen && <BiltyReportView open={biltyReportOpen} onClose={handleBiltyReportViewClose} pdfType={checkPdf} />}
        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({

    dipatchGetConsigneePdf: (tripId, onSuccess, onError) => {
        dispatch(getCongineePdf(tripId, onSuccess, onError))
    },
    disptachGetConsignorPdf: (tripId, onSuccess, onError) => {
        dispatch(getConsignorPdf(tripId, onSuccess, onError))
    }

});

export default connect(mapStateToProps, mapDispatchToProps)(BiltyReportPreview);